import axios from 'axios';
import { Env } from '@/configuration';
import { PlayerListItem } from './models';

const fetchPlayers = async (seasonId?: number) => {
  const playersUrl = Env.AdminApiOptions.endpointUrl(seasonId ? `players/${seasonId}` : 'players');

  return await axios.get(playersUrl)
    .then((response: any) => {
      const result: PlayerListItem[] = response && response.data;
      return result;
    });
};

export default {
  fetchPlayers,
};
